import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import * as Icon from 'react-feather';
import { CSVLink } from 'react-csv';
import { Button, Input, Spinner } from 'reactstrap';
import FormSelect from '../form/FormSelect';
import CurrentTime from './CurrentTime';

const AdminHeader = (props) => {
  const {
    title,
    isSearch = false,
    onSearchClick,
    onExportClick,
    isExporting = false,
    setIsCsvDownload,
    isCsvDownload = false,
    isExport = false,
    isImport = false,
    csvProps,
    isExpandSearch = false,
    searchPlaceholder = 'Search',
    search = '',
    handelSearch,
    isAdd = false,
    isBack = false,
    addBtnName = '',
    backBtnName = '',
    onAddClick,
    onBackClick,
    onImportClick,
    isAddDisabled = false,
    isImportDisabled = false,
    isExportDisabled = false,
    isDeleteImportDisabled = false,
    isExpandSelect = false,
    options = [],
    selectValue = '',
    selectPlaceholder = 'Select',
    handelSelect,
    isRefresh = false,
    onRefreshClick,
    isZipDownload = false,
    onZipDownload,
    isDeleteImport = false,
    onDeleteImportClick,
    isManualExport = false,
    onCopyClick,
    copyBtnName = '',
    isCopy = false,
    form_id = null,
    isMultiAdd = false,
    multiAddBtn = [],
    isLoading = false
  } = props;

  const excelRef = useRef();

  useEffect(() => {
    if (isCsvDownload && !isExporting && isExport) {
      excelRef?.current.link?.click();
      setIsCsvDownload(false);
    }
  }, [isCsvDownload]);

  return (
    <div className="w-100 d-flex justify-content-between align-items-center pb-3">
      <label className="fs-3 fw-bolder text-primary">{title}</label>
      <div className="d-flex justify-content-end align-items-center">
        {isExpandSearch && (
          <div className="me-2">
            <Input
              className="form-control"
              name="search"
              type="text"
              placeholder={searchPlaceholder}
              value={search}
              onChange={handelSearch}
            />
          </div>
        )}
        {isExpandSelect && (
          <div className="me-2">
            <FormSelect
              isShowLabel={false}
              className="callex-mb-0"
              inputClassName="select-input-w"
              name="select"
              placeholder={selectPlaceholder}
              value={selectValue}
              options={options}
              onChange={handelSelect}
            />
          </div>
        )}
        {isBack && (
          <Button className="bg-transparent text-primary me-2 px-3" onClick={onBackClick}>
            {backBtnName}
          </Button>
        )}
        {isCopy && (
          <Button className="bg-violet me-2" onClick={onCopyClick} disabled={isAddDisabled}>
            {copyBtnName}
          </Button>
        )}
        {isAdd && (
          <Button
            className="bg-primary text-white me-2 d-flex justify-content-center align-items-center gap-2"
            onClick={onAddClick}
            disabled={isAddDisabled || isLoading}
            form={form_id || undefined}
            type={form_id ? 'submit' : 'button'}>
            {addBtnName}
            {isLoading && <Spinner size="sm" color="light" />}
          </Button>
        )}
        {isMultiAdd &&
          multiAddBtn.map((val, index) => {
            return (
              <Button
                key={index}
                className="bg-primary me-2"
                onClick={val.onClick}
                disabled={val.isDisabled}>
                {val.name}
              </Button>
            );
          })}
        {isSearch && (
          <div
            className="me-2 bg-info rounded-2 d-flex justify-content-center align-items-center"
            style={{ width: '30px', height: '30px', cursor: 'pointer' }}
            onClick={onSearchClick}>
            <Icon.Search size={20} className="text-white" />
          </div>
        )}
        {isExport ? (
          isExporting ? (
            <div
              className="me-2 bg-success rounded-2 d-flex justify-content-center align-items-center"
              style={{ width: '30px', height: '30px', cursor: 'pointer' }}>
              <Spinner size="sm" color="light" />
            </div>
          ) : (
            <>
              <div
                className={`me-2 bg-success rounded-2 d-flex justify-content-center align-items-center ${
                  isExportDisabled ? 'callex-disabled' : ''
                }`}
                style={{ width: '30px', height: '30px', cursor: 'pointer' }}
                onClick={() => {
                  if (!isExportDisabled) {
                    onExportClick();
                  }
                }}>
                <Icon.Download size={20} className="text-white" />
              </div>
              {isCsvDownload && !isExportDisabled && !isManualExport && (
                <CSVLink
                  {...csvProps}
                  ref={excelRef}
                  className="hiddenExcel"
                  target="_blank"></CSVLink>
              )}
            </>
          )
        ) : null}
        {isRefresh && (
          <div
            className="me-2 bg-secondary rounded-2 d-flex justify-content-center align-items-center"
            style={{ width: '30px', height: '30px', cursor: 'pointer' }}
            onClick={onRefreshClick}>
            <Icon.RefreshCw size={20} className="text-white" />
          </div>
        )}
        {isZipDownload && (
          <div
            className="me-2 bg-violet rounded-2 d-flex justify-content-center align-items-center"
            style={{ width: '30px', height: '30px', cursor: 'pointer' }}
            onClick={onZipDownload}>
            <Icon.DownloadCloud size={20} className="text-white" />
          </div>
        )}
        {isImport ? (
          <Button
            className="bg-info border-info me-2"
            onClick={onImportClick}
            disabled={isImportDisabled}>
            Import
          </Button>
        ) : null}
        {isDeleteImport ? (
          <Button
            className="bg-danger border-danger me-2"
            onClick={onDeleteImportClick}
            disabled={isDeleteImportDisabled}>
            Delete Import
          </Button>
        ) : null}
        <CurrentTime />
      </div>
    </div>
  );
};

AdminHeader.propTypes = {
  title: PropTypes.string,
  isSearch: PropTypes.bool,
  onSearchClick: PropTypes.func,
  onExportClick: PropTypes.func,
  isExporting: PropTypes.bool,
  csvProps: PropTypes.array,
  isCsvDownload: PropTypes.bool,
  isExport: PropTypes.bool,
  isExpandSearch: PropTypes.bool,
  setIsCsvDownload: PropTypes.func,
  searchPlaceholder: PropTypes.string,
  search: PropTypes.any,
  handelSearch: PropTypes.func,
  isAdd: PropTypes.bool,
  isBack: PropTypes.bool,
  isImport: PropTypes.bool,
  isAddDisabled: PropTypes.bool,
  isImportDisabled: PropTypes.bool,
  isExportDisabled: PropTypes.bool,
  isManualExport: PropTypes.bool,
  isDeleteImportDisabled: PropTypes.bool,
  isExpandSelect: PropTypes.bool,
  isRefresh: PropTypes.bool,
  isZipDownload: PropTypes.bool,
  isDeleteImport: PropTypes.bool,
  addBtnName: PropTypes.string,
  onAddClick: PropTypes.func,
  backBtnName: PropTypes.string,
  onBackClick: PropTypes.func,
  onImportClick: PropTypes.func,
  options: PropTypes.array,
  selectValue: PropTypes.any,
  selectPlaceholder: PropTypes.string,
  handelSelect: PropTypes.func,
  onRefreshClick: PropTypes.func,
  onZipDownload: PropTypes.func,
  onDeleteImportClick: PropTypes.func,
  onCopyClick: PropTypes.func,
  copyBtnName: PropTypes.string,
  isCopy: PropTypes.bool,
  form_id: PropTypes.string,
  multiAddBtn: PropTypes.array,
  isMultiAdd: PropTypes.bool,
  isLoading: PropTypes.bool
};

export default AdminHeader;
